<div class="note">
  <app-modal-close-button
    [closeDialog]="closeDialog.bind(this)"
    class="close-button"></app-modal-close-button>
  <p>{{ data.resident.internalNote }}</p>
  <mat-icon
    *ngIf="permissionsService.canManageResidents()"
    svgIcon="edit-icon"
    class="edit-icon"
    (click)="openEditNoteModal()"></mat-icon>
</div>
